const stringifyValue = (value, maxArrayItems = 20) => {
	if (Array.isArray(value)) {
		const items = value.slice(0, maxArrayItems).map((item) => stringifyValue(item, maxArrayItems));
		return `[${items.join(", ")}${value.length > maxArrayItems ? ", ..." : ""}]`;
	}

	if (value && typeof value === "object") {
		try {
			return JSON.stringify(value, null, 2); // nicely formatted object
		} catch {
			return String(value); // fallback if object has circular refs
		}
	}

	if (typeof value === "string") {
		return value;
	}

	if (value === null) {
		return "null";
	}

	if (value === undefined) {
		return "undefined";
	}

	return String(value); // numbers, booleans, symbols
};

export default stringifyValue;
